import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import curry from 'lodash/curry'
import { compose } from 'redux'

import LeftHeaderGrid from './LeftHeaderGrid'
import LeftBodyGrid from './LeftBodyGrid'
import ColumnGrid from './ColumnGrid'

import styles from './styles.scss'

const gridContainerHoc = curry((Container, props) => {
  const {
    cellRenderer,
    headerCellRenderer,
    leftCellRenderer,
    leftHeaderCellRenderer,
    ...rest
  } = props
  return (
    <Container>
      <LeftHeaderGrid
        {...rest}
        cellRenderer={leftHeaderCellRenderer}
      />
      <LeftBodyGrid
        {...rest}
        cellRenderer={leftCellRenderer}
      />
      <ColumnGrid
        {...rest}
        headerCellRenderer={headerCellRenderer}
        cellRenderer={cellRenderer}
      />
    </Container>
  )
})

const GridContainer = props => (
  <div styleName='gridColumn'>
    { props.children }
  </div>
)

const withStyles = CSSModules(styles)

// returns a hof that requires props
const enhance = compose(
  gridContainerHoc,
  withStyles,
)

export {
  enhance,
  GridContainer
}
export default enhance(GridContainer)
